"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15.611 10.061a.309.309 0 1 0-.415-.453l-2.945 2.677a.39.39 0 0 1-.501 0L8.805 9.608a.31.31 0 0 0-.416.454l2.13 1.939-2.13 1.937-.013.012a.31.31 0 0 0 .428.446l2.174-1.977.355.323a1.01 1.01 0 0 0 1.332 0l.355-.322 2.174 1.976.013.012a.31.31 0 0 0 .403-.469l-2.13-1.937 2.13-1.939z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m4.95 11.034a.93.93 0 0 1-.928.928H7.978a.93.93 0 0 1-.928-.928V9.215a.93.93 0 0 1 .928-.928h8.044a.93.93 0 0 1 .928.928z"
  })]
}), 'EmailRing');
//# sourceMappingURL=index.js.map